<template>
    <div>
        <div class="text-center" v-if="vertical">
            <div>
                <slot></slot>
            </div>
            <div class="mt-3 text-center" v-if="action && !disabled">
                <base-button type="primary" :size="buttonSize" @click="handler" :loading="loading" :disabled="disabled">
                    <i :class="icon+' mr-1'" v-if="icon"></i> {{ action }}
                </base-button>
                <small class="d-block mt-2" v-if="help">{{ help }}</small>
            </div>
        </div>

        <div class="row align-items-center" v-else>
            <div class="col text-left" :class="{'text-small':reduceText}">
                <slot></slot>
            </div>
            <div class="col-auto text-center" v-if="action && !disabled">
                <base-button type="primary" :size="buttonSize" @click="handler" :loading="loading" :disabled="disabled">
                    <i :class="icon+' mr-1'" v-if="icon"></i> {{ action }}
                </base-button>
                <small class="d-block mt-2" v-if="help">{{ help }}</small>
            </div>
        </div>

    </div>
</template>

<script>
    export default {

        props: {

            vertical: {
                type: Boolean,
                default: false
            },

            reduceText: {
                type: Boolean,
                default: true
            },

            reduceButton: {
                type: Boolean,
                default: true
            },

            action: {
                type: String,
                default: null
            },

            icon: {
                type: String,
                default: null
            },

            handler: {
                type: Function,
                required: true
            },

            help: {
                type: String,
                default: null
            },

            loading: {
                type: Boolean,
                default: false
            },

            disabled: {
                type: Boolean,
                default: false
            },
        },

        computed: {

            buttonSize() {
                if (this.vertical) {
                    return null
                }
                if (this.reduceButton) {
                    return 'sm'
                }
                return null
            }
        }
    }
</script>

<style scoped>

    .text-small {
        font-size: 80%;
    }

</style>